import React from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

const MandateStatus = ({
  success = true,
  onContinue,
}) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="80vh"
      bgcolor="#f5f7fb"
    >
      <Paper
        elevation={3}
        style={{
          width: 500,
          borderRadius: 16,
          padding: "50px 40px",
          textAlign: "center",
        }}
      >
        {success ? (
          <>
            <CheckCircleIcon
              style={{
                fontSize: 90,
                color: "#22c55e",
              }}
            />

            <Typography
              variant="h4"
              style={{
                marginTop: 20,
                color: "#15254F",
                fontWeight: 700,
              }}
            >
              Mandate Successful
            </Typography>

            <Typography
              style={{
                marginTop: 20,
                color: "#555",
                lineHeight: 1.8,
              }}
            >
              Your eMandate has been registered successfully.
              <br />
              You can now continue your loan journey.
            </Typography>
          </>
        ) : (
          <>
            <CancelIcon
              style={{
                fontSize: 90,
                color: "#ef4444",
              }}
            />

            <Typography
              variant="h4"
              style={{
                marginTop: 20,
                color: "#15254F",
                fontWeight: 700,
              }}
            >
              Mandate Failed
            </Typography>

            <Typography
              style={{
                marginTop: 20,
                color: "#555",
                lineHeight: 1.8,
              }}
            >
              We couldnot register your eMandate.
              <br />
              Please try again to continue your loan journey.
            </Typography>
          </>
        )}

        {/* <Button
          variant="contained"
          color="primary"
          fullWidth
          style={{
            marginTop: 40,
            height: 50,
            borderRadius: 10,
            textTransform: "none",
            fontSize: 16,
            fontWeight: 600,
            background: "#15254F",
          }}
          onClick={onContinue}
        >
          {success ? "Continue Journey" : "Retry Mandate"}
        </Button>

        <Button
          style={{
            marginTop: 15,
            textTransform: "none",
          }}
          onClick={() => (window.location.href = "/dashboard")}
        >
          Go to Dashboard
        </Button> */}
      </Paper>
    </Box>
  );
};

export default MandateStatus;